var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type == "login")?_c('div',[_c('loginpage',{attrs:{"routerAddress":_vm.routerAddress,"address":_vm.address}})],1):_vm._e(),(_vm.type == "register")?_c('div',[_c('registerpage')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }